import { Files } from '../../lib/constants/files'
import { Ol } from '../../lib/types/models/ol/ol'
import { OlInput, OlRequest } from '../../lib/types/models/ol/ol-input'
import { UpdateInput } from '../../lib/types/utils'
import { uploadFile } from '../../lib/utils/functions/file.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const updateOl = async (data: UpdateInput<OlInput>) => {
  const { id, isActive: _isActive, comments, bankAccounts, ...rest } = data

  rest.mainContactPicture = await uploadFile(Files.OL_PICTURE, rest.mainContactPicture)

  if (rest.files)
    for (let i = 0; i < rest.files.length; i++) {
      const newFile = await uploadFile(Files.OL_PICTURE, rest.files[i])
      if (newFile) rest.files[i] = { ...newFile }
    }

  return restApiClient
    .url(constructApiUrl(API.ols.update.url, { id }))
    .patch<
      Ol,
      Partial<OlRequest>
    >({ ...rest, comments: (comments ?? []).map(({ id, comment }) => ({ id, comment })), bankAccounts: (bankAccounts ?? []).map((b) => ({ ...b, hostCountries: b.hostCountries.map(({ id }) => id) })) })
}
